/** Shared splash text parsing / defaults for API + client fallback. */

export const DEFAULT_SPLASH_TEXTS: string[] = [
  "Also try WASD!",
  "Don't touch the red!",
  "Now with Golf!",
  "Q and E for Superdot!",
  "Rankings await!",
  "Sandbox forever!",
  "One more run!",
];

/** Raw stored line length (includes `[target]` markup). */
const MAX_SPLASH_LEN = 200;
const MAX_SPLASH_COUNT = 2000;

export function normalizeSplashTexts(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  const out: string[] = [];
  for (const item of raw) {
    if (typeof item !== "string") continue;
    const line = item.replace(/\r/g, "").trim();
    if (!line) continue;
    out.push(line.slice(0, MAX_SPLASH_LEN));
    if (out.length >= MAX_SPLASH_COUNT) break;
  }
  return out;
}

/** Parse admin textarea: one splash per line (Enter). */
export function splashTextsFromTextarea(body: string): string[] {
  return normalizeSplashTexts(
    String(body || "")
      .replace(/\r\n/g, "\n")
      .replace(/\r/g, "\n")
      .split("\n"),
  );
}

export function splashTextsToTextarea(texts: string[]): string {
  return texts.join("\n");
}
